import moment from 'moment';

export const nullToString = (input) => {
    if (input === null) return '';
    return input;
};

export function getCnyText(cny) {
    switch (cny) {
    case 'TWD': return '新台幣';
    case 'USD': return '美金';
    case 'HKD': return '港幣';
    case 'GBP': return '英鎊';
    case 'AUD': return '澳幣';
    case 'CAD': return '加幣';
    case 'JPY': return '日圓';
    case 'EUR': return '歐元';
    case 'CNY': return '人民幣';
    default: return '';
    }
}

export function isBeforeSunPayChangeServerDate(platform, date) {
    const sunPayChangeDate = moment('2025-07-01');
    return platform === 'SunPay' && moment(date).isBefore(sunPayChangeDate);
}
